const howToGetArcanium = `

#### From Level 1
- Kill monsters all over the **Rappelz World** to obtain **Arcanium Fragments**.

#### Exchange Rate for Arcanium Fragments
- Visit the **Arcanium Manager** in any city to exchange **Arcanium Fragments** for **Arcanium**.
- **12x daily**, the exchange rate **changes randomly**.
- **Standard rate**: **10:1** (10 Arcanium Fragments = 1 Arcanium)

#### Duration of Exchange Rates:
| **Exchange Rate** | **Duration Per Day** |
|------------------|-------------------|
| 10:1            | 4x 4 hours        |
| 12:1            | 4x 1 hour 30 min  |
| 8:1             | 4x 15 minutes     |

⚠️ **Rate changes are not announced and may repeat randomly!**

---

#### From Level 10
- **Arcanium Lottery** available at **Arcanium Manager** in every city.
- Win the **jackpot** with luck!
- After a win, the **jackpot resets to 500 Arcanium**.

#### From Level 110
- Weekly quests available at the **Arcanium Manager**.
- Quest Levels: **110/140/150/160/170/180/190**.

#### From Level 150
- Collect **1-2 Arcanium** every **4 hours** at the **Arcanium Manager** in every city.

---

#### Other Ways to Obtain Arcanium
- **By donating to the server**.`;

export default howToGetArcanium;
